import RestaurantIcon from '@/assets/icons/restaurant-white.svg?react';
import { ServiceReservationGuide } from '@/components/ServiceReservationGuide';

export function DinnerAccessRestrictedGuide() {
    return (
        <ServiceReservationGuide
            icon={<RestaurantIcon className="icon-svg" />}
            title="석식 신청 안내"
            description="현재 이 서비스는 이용이 제한되어 있습니다. 이용이 필요하시면 관리자에게 문의해주세요."
            detailLabel="현재 상태"
            detailValue="이용 제한"
            iconBackgroundColor="#F59E0B"
        />
    );
}
